import { useRef } from 'react';

import { getCustomId } from '@ulta/core/utils/getCustomId/getCustomId';

/**
 * useUuid
 * @description A custom react hook to generate a unique id string.
 * @returns {array} An array with a single element, the unique id string.
 * @example
 * const [id] = useUuid();
 *
 */
export const useUuid = () => {
  const id = useRef( getCustomId() );
  return [id.current];
};


